import React, { useEffect } from "react";
import { useNavContext } from "../../context-api/nav-context";
import PageHeaderSmall from "../../components/PageHeaderSmall";
import BlogImage from "../../components/BlogImage";

const BathroomCheck = () => {
  const { closeNavbarMenu } = useNavContext();
  const title = "Checklist For Planning a New Bathroom";
  const imgOne =
    "https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_700/v1643280217/AquaHeat/Navbar%20Images/bathrooms_uzoqlf.webp";
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <PageHeaderSmall title={title} />
      <BlogImage img={imgOne} onMouseOver={closeNavbarMenu} />
      <section
        className="section-wrapper conditions_global"
        onMouseOver={closeNavbarMenu}
      >
        <div className="conditions_body">
          <h2 className="conditions_subtitle">
            The Essential Bathroom Design Checklist
          </h2>
          <p className="conditions_paragraph">
            Redesigning your bathroom is an exciting yet challenging task, but
            before diving headfirst into ripping the entire suite out there are
            a few important things that should be carefully considered. We
            understand that remodeling a bathroom can be tricky, time consuming
            and not to mention costly, so to help your project stay on track and
            run smoothly we have created this essential checklist.
          </p>
          <h2 className="conditions_subtitle">Setting a budget</h2>
          <p className="conditions_paragraph">
            The first step on our bathroom design checklist is to set a budget,
            as this will help you to make decisions about what to include in
            your renovation project. Once you have figured out what you can
            afford to spend and taken into account labour costs, you will have a
            clearer idea on what you can afford for fixtures, fittings,
            materials, etc. Remember, you don’t have to spend a fortune to
            create the look you really want.
          </p>
          <h2 className="conditions_subtitle">Time-frame</h2>
          <p className="conditions_paragraph">
            If you have a small bathroom, don’t assume that it will be any
            easier to design or require any less planning. Regardless of the
            shape or size of your bathroom, you will need to pay close attention
            to detail. You will also need to factor in the ordering and
            purchasing of tiles, materials and fixtures and ensure they can be
            delivered when your bathroom fitter needs them.
          </p>
          <p className="conditions_paragraph">
            The time-frame is a crucial element if you only have one bathroom in
            your home, as you’ll need to make arrangements where to shower and
            use the toilet while the bathroom is being worked on.
          </p>
          <p className="conditions_paragraph">
            It’s a good idea to allow extra time for any hidden problems that
            may arise with your bathroom upgrade. Unless you are highly
            experienced at DIY and plumbing, we recommend hiring a professional
            to carry out your bathroom installation to ensure it functions
            without any issues.
          </p>
          <h2 className="conditions_subtitle">
            Hire professionals like AquaHeat
          </h2>
          <p className="conditions_paragraph">
            You may think it appears simple to fit your new basin or toilet, but
            if you aren’t experienced at DIY, unforeseen plumbing problems can
            happen that you may not know how to deal with. So, if you want your
            bathroom design project to be a success, don’t overlook the
            advantages that a specialist contractor can offer.
          </p>
          <h2 className="conditions_subtitle">Choosing bathroom fixtures</h2>
          <p className="conditions_paragraph">
            The right choice of fixtures such as basins, toilets, taps, showers,
            baths, vanity units, accessories, and not to mention heating and
            lighting, can make or break your bathroom design.
          </p>
          <p className="conditions_paragraph">
            Bathroom fixtures are available in an array of styles ranging from
            the sleek and modern to the elegant and traditional to suit all
            tastes. If you have a small bathroom, opt for compact fittings to
            maximise space. Wall mounted basins and toilets are ideal for making
            your bathroom appear more spacious. For those who have plenty of
            room to play with, why not consider a freestanding bath and a
            separate walk-in shower for a luxury look?
          </p>
          <p className="conditions_paragraph">
            Don’t forget to factor in storage, which is essential for any
            bathroom small or large. Vanity units offer a stylish and practical
            storage solution as they combine a sink and drawers or a cupboard
            underneath where you can keep toiletries hidden away. They come in
            wall mounted and floor standing designs, as well as a choice of
            finishes ranging from white gloss to walnut. If you have an awkward
            shaped bathroom, a corner vanity unit can offer a great solution.
          </p>
          <h2 className="conditions_subtitle">The walls & floor</h2>
          <p className="conditions_paragraph">
            As long as it’s waterproof, almost any material can used in the
            bathroom. Your choice of material for the walls and floors will
            depend on your budget. If you have a bit more to splash out you
            could opt for marble or granite for a touch of luxury. For those on
            a lower budget, there’s marble effect tiles, so you can get the look
            but without breaking the bank. Vinyl flooring is another option for
            those on a limited budget. There are many designs to take your pick
            from, plus it doesn’t feel cold underfoot either! Whatever your
            choice of bathroom flooring, just make sure it is both durable and
            slip resistant.
          </p>
          <h2 className="conditions_subtitle">Bathroom heating & lighting</h2>
          <p className="conditions_paragraph">
            The heating and lighting play important roles in your bathroom
            design. The space should have task lighting, as well as mood
            lighting to create a relaxing ambience, so plan to incorporate both
            into the design. Ensure any lighting you choose is suitable for use
            in the bathroom and that it uses energy saving LED technology.
          </p>
          <p className="conditions_paragraph">
            When it comes to heating, we recommend fitting both underfloor
            heating and a heated towel rail in your new bathroom. Underfloor
            heating keeps the room warm and dry, while a heated towel rail
            provides the basic luxury of toasty towels.
          </p>
          <h2 className="conditions_subtitle">Bathroom accessories</h2>
          <p className="conditions_paragraph">
            The final thing to think about is accessories. They may seem like an
            insignificant part of your bathroom design project, but the right
            style can enhance the overall space and bring everything together.
            Accessories such as glass shelves, toilet roll holders and towel
            rails will ensure your bathroom is functional.
          </p>
        </div>
      </section>
    </>
  );
};

export default BathroomCheck;
